import constructionMobileExt from '@/assets/illustrations/industry card construction mobile EXT.svg'
import eventsMobileExt from '@/assets/illustrations/industry card Events mobile EXT.svg'
import tvFilmMobileExt from '@/assets/illustrations/industry card TV Film mobile EXT.svg'
import facilitiesMobileExt from '@/assets/illustrations/industry card FM mobile  EXT.svg'

// Extended mobile hero illustrations — same artwork as
// IndustryPickerSection/industries.ts, with more clearance at the bottom so
// the hero headline doesn't overrun it. Hero-only: the industry-panel picker
// keeps the original mobile asset. Desktop is unaffected either way.
export const HERO_MOBILE_ILLUSTRATION_EXT: Record<string, string> = {
    construction: constructionMobileExt,
    events: eventsMobileExt,
    'tv-film': tvFilmMobileExt,
    facilities: facilitiesMobileExt,
}

export default HERO_MOBILE_ILLUSTRATION_EXT
